import React, { Fragment, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_RESP_STATUS } from "../../Constant/constant";
import { getAccountList, getCategoryList, deleteCategory } from "../Apis/apis";
import AddDailog from "../Record/AddDailog";
import AllStateContext from "../../context/allstateContext";
import AccountDialog from "../Record/AccountDialog";
import DateDialog from "../../Common/DateDialog";
import TimeDialog from "../../Common/TimeDialog";
import { useQuery } from "react-query";
import AddNewAccountDialog from "../../Common/AddNewAccountDialog";
import DeletedConfirmationDialog from "../../Common/DeletedConfirmationDialog";
import AddNewCategoryDialog from "../../Common/AddNewCategoryDialog";
import CategoryTransactionsDialog from "../../Common/CategoryTransactionsDialog";
import { formatDateMonthYear } from "../../Common/Common";

const Categories = () => {
  const history = useNavigate();
  const [groupData, setGroupData] = useState([]);
  const {
    openAccount,
    openDateDialog,
    openTimeDialog,
    openDeleteConfirmationDialog,
    setOpenDeleteConfirmationDialog,
    addNewAccountDialog,
    openAddNewCategoryDialog,
    setOpenAddNewCategoryDialog,
    selectedCategoriesItem,
    setSelectedCategoriesItem,
    setSearchDetail,
    startEndDate,
  } = useContext(AllStateContext);
  const [showCategoryTx, setShowCategoryTx] = useState(false);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const { data, error, isLoading, refetch } = useQuery(
    ["CategoriesListApiCall"],
    async () => {
      const response = await getCategoryList();
      setGroupData(
        response.data?.payload?.data?.reduce((acc, item) => {
          const type = item.type;
          acc[type] = acc[type] || [];
          acc[type].push(item);
          return acc;
        }, {})
      );
      return response.data;
    }
  );
  if (error) {
    if (error.response.status == API_RESP_STATUS.unauthorized) {
      localStorage.removeItem("token");
      history("/login");
    }
  }

  const [deleteItemId, setDeleteItemId] = useState(null);
  const handelEdit = async (item, event) => {
    if (event === "edit") {
      setSelectedCategoriesItem(item);
      setOpenAddNewCategoryDialog(true);
    } else {
      setDeleteItemId(item.categoryId);
      setOpenDeleteConfirmationDialog(true);
    }
  };
  const handelDeleted = async () => {
    if (!deleteItemId) return;
    try {
      await deleteCategory(deleteItemId);
      refetch();
    } catch (err) {
      console.error("Delete category failed:", err);
    }
    setDeleteItemId(null);
  };
  return (
    <div className="container" style={{ paddingBottom: "40px", marginTop: "80px" }}>
      <div>
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <AddDailog fetchData={refetch} />
            {openAccount && <AccountDialog />}
            {openDateDialog && <DateDialog />}
            {openTimeDialog && <TimeDialog />}
            {openDeleteConfirmationDialog && (
              <DeletedConfirmationDialog isDeleted={handelDeleted} />
            )}
            {addNewAccountDialog && <AddNewAccountDialog refetch={refetch} />}
            {openAddNewCategoryDialog && (
              <AddNewCategoryDialog refetch={refetch} />
            )}
            <CategoryTransactionsDialog
              open={showCategoryTx}
              onClose={() => {
                setShowCategoryTx(false);
                setSelectedCategoryName("");
              }}
              categoryName={selectedCategoryName}
              startDate={formatDateMonthYear(startEndDate.startDate)}
            />

            <div className="glass-card">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h5 style={{ fontWeight: "700", margin: "0", letterSpacing: "0.02em" }}>
                  Categories Management
                </h5>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setOpenAddNewCategoryDialog(true)}
                  style={{ padding: "8px 18px", fontSize: "0.88rem", fontWeight: "600" }}
                >
                  <img
                    style={{ width: "16px", height: "16px", filter: "invert(1)" }}
                    src={require("../../Common/Icon/plus.png")}
                    alt="plus"
                  />
                  Add Category
                </button>
              </div>

              {groupData && Object.keys(groupData).length > 0 ? (
                Object.entries(groupData)?.map(([type, items]) => (
                  <div key={type} style={{ marginBottom: "24px" }}>
                    <div className="d-flex align-items-center mb-3">
                      <span 
                        className={type == 2 ? "badge-income" : "badge-expense"}
                        style={{ fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "0.05em", padding: "4px 12px" }}
                      >
                        {type == 2 ? "Income Categories" : "Expense Categories"}
                      </span>
                    </div>

                    <div className="list-group" style={{ margin: "0", border: "1px solid var(--border-color)" }}>
                      {items?.map((item) => (
                        <div 
                          className="list-group-item d-flex align-items-center justify-content-between" 
                          key={item?.categoryId}
                          style={{
                            padding: "14px 20px !important",
                            borderBottom: "1px solid var(--border-color)",
                            cursor: "pointer"
                          }}
                        >
                          <div 
                            className="d-flex align-items-center gap-3"
                            style={{ flex: 1 }}
                            onClick={() => {
                              setSelectedCategoryName(item.name);
                              setShowCategoryTx(true);
                            }}
                          >
                            <div 
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                background: "var(--bg-surface-hover)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid var(--border-color)"
                              }}
                            >
                              <img
                                style={{ height: "24px", width: "24px" }}
                                src={item?.iconDetail?.icon}
                                alt={item?.name}
                              />
                            </div>
                            <span style={{ fontWeight: "600", fontSize: "0.95rem" }}>
                              {item.name}
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <button
                              onClick={() => handelEdit(item, "edit")}
                              className="btn btn-secondary"
                              style={{ width: "32px", height: "32px", padding: "0", minWidth: "32px", borderRadius: "8px" }}
                            >
                              <img style={{ width: "12px", height: "12px", filter: "invert(1)" }} src={require("../../Common/Icon/edit.png")} alt="edit" />
                            </button>
                            <button
                              onClick={() => handelEdit(item, "delete")}
                              className="btn btn-secondary"
                              style={{ width: "32px", height: "32px", padding: "0", minWidth: "32px", borderRadius: "8px", background: "rgba(239, 68, 68, 0.05)", borderColor: "rgba(239, 68, 68, 0.1)" }}
                            >
                              <img style={{ width: "12px", height: "12px", filter: "invert(1)" }} src={require("../../Common/Icon/delete_icon.png")} alt="delete" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-5 text-muted" style={{ fontSize: "0.9rem" }}>
                  No categories found.
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Categories;
